import React from "react";
import { Col, Row, Button, Layout } from "antd";
import Notfound from "../../assets/images/404.jpg";
import logo from "../../assets/images/logo.svg";
import { useNavigate } from "react-router-dom";
import CONFIG from "../../utils/config";
const { Header } = Layout;

function PageNotFound() {
  const {
    ROUTES: { USERS },
  } = CONFIG;

  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(USERS.path);
  };

  return (
    <div>
      <Header>
        <img src={logo} alt="logo" />
      </Header>
      <Row className="unauthorised-page">
        <Col className="gutter-row" xs={8}>
          <h2>Ooops....</h2>
          <h3>Page Not Found</h3>
          <Button className="primary-solid" onClick={handleRedirect}>
            Go to User Managment
          </Button>
        </Col>
        <Col className="gutter-row" xs={8}>
          <img src={Notfound} alt="noAccess" />
        </Col>
      </Row>
    </div>
  );
}

export default PageNotFound;
